import { makeLegendFormatter } from '../utils/legend-formatter.js'

const volatileGasChartOptions = {
  height: 320,
  labels: ['Datetime', 'Voc Index'],
  colors: ['#159B00', '#F21818', '#1C579F', '#C6C6C6', '#8E8E8E', '#5B5B5B', '#383838'],
  labelsDiv: 'legendDivVoc',
  labelsSeparateLines: false,
  legend: 'always',
  legendFormatter: makeLegendFormatter(),
  animatedZooms: true,
}

export {
  volatileGasChartOptions
}